import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {MobileLayout} from '@/modules/layout/app-layout/components/mobile-layout'
import {useBreakpointValue} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/activity')({
  component: ActivityLayout,
})

function ActivityLayout() {
  const {t} = useTranslate('common')
  const isMobile = useBreakpointValue({base: true, md: false}) ?? false
  return isMobile ? <MobileLayout title={t('activity')} /> : <AppLayout hideSideDrawer />
}
